import SurveyChoiceOverviewCard from './surveyChoiceOverviewCard.container';
export default SurveyChoiceOverviewCard